import React from 'react';
import { Button, Tooltip } from '@myua/kit';
import { useDispatch, useSelector } from 'react-redux';
import * as finderActions from '../actions';
import { getDetailsVisible } from '../selectors';
import { PanelFilledIcon, PanelOutlineIcon } from '../../icons/PanelToggle';

// Кнопка-тогл сайдбара деталей в шапке (рядом с Upload).
// Залитая иконка — сайдбар открыт, контурная — свёрнут.
// Сворачивание (и здесь, и крестиком внутри сайдбара) работает одинаково:
// сайдбар не раскрывается автоматически при выборе ассета, пока его не откроют
// вручную — этой кнопкой (MYUA-16254) или повторным кликом по уже выбранному ассету.
export const DetailsToggleButton: React.FC = () => {
  const dispatch = useDispatch();
  const visible = useSelector(getDetailsVisible);

  const tooltipText = visible ? 'Hide the details panel' : 'Show the details panel';

  const onClick = () => {
    dispatch(finderActions.setDetailsVisible({ visible: !visible }));
  };

  return (
    <Tooltip title={tooltipText} placement="bottom">
      <Button
        className="al-details-toggle-button"
        aria-label={visible ? 'Hide details panel' : 'Show details panel'}
        icon={visible ? <PanelFilledIcon /> : <PanelOutlineIcon />}
        onClick={onClick}
      />
    </Tooltip>
  );
};
